import React from 'react';
import ContentBuilder from '../../core/ContentBuilder';
import styles from './LargeNumber.module.scss';

export class LargeNumber extends React.Component
{
	render()
	{
		let content = this.props['children'];
		if(Array.isArray(content) && content.length == 1 && typeof(content[0]) == 'string')
		{
			let children = [];
			content = content[0].split(/(\d+)/).forEach((v) => {
				if(/^\d+$/.test(v))
				{
					children.push({tag: 'span', props: {className: 'n'}, content: v});
				}else if(v.length > 0)
				{
					children.push(v)
				}
			});
			content = children;
		}
		return (
			<span className={styles['content']}>{ContentBuilder.build(content, {}, styles)}</span>
		)
	}
}